const getAtomUuid = (globalMapping, id) => atom => (globalMapping[id] || [])[atom.idx];
const isBaseSubstrate = node => node.isBaseSubstrate;
const getColor = (palette, index) => palette[index % palette.length];

export const getAllSurvivingAtomsColorMapping = (nodes, globalMapping, colorPalette) => {
  const getAtomUuids = (acc, curr) => {
    return {
      ...acc,
      [curr.id]: Object.values(curr.drawnMol.atoms).map(getAtomUuid(globalMapping, curr.id)),
    };
  };

  const assignColor = (palette, index) => (acc, curr) => {
    const res = {
      ...acc,
      [curr]: getColor(palette, index),
    };
    return res;
  };

  const assingColors = (acc, curr, index) => {
    return {
      ...acc,
      ...curr.reduce(assignColor(colorPalette, index), {}),
    };
  };

  const atomUuids = Object.values(nodes).filter(isBaseSubstrate).reduce(getAtomUuids, {});

  const atomColors = Object.values(atomUuids).reduce(assingColors, {});

  for (const node of Object.values(nodes)) {
    const uuids = Object.values(node.drawnMol.atoms).map(getAtomUuid(globalMapping, node.id));
    let colors = {};
    for (const atomId of uuids) {
      const color = atomColors[atomId];
      if (color != null) {
        if (colors[color] == null) {
          colors[color] = [];
        }
        colors[color].push(atomId);
      }
    }
    colors = Object.keys(colors);
    if (colors.length === 1) {
      for (const atomId of uuids) {
        if (atomColors[atomId] == null) {
          atomColors[atomId] = colors[0];
        }
      }
    }
  }
  return atomColors;
};

export const applyColorMapping = (id, mol, colorMapping, globalMapping) => {
  const compoundMapping = globalMapping[id] || [];
  Object.values(mol.atoms).forEach((atom, index) => {
    const atomUuid = compoundMapping[index];
    atom.color = colorMapping[atomUuid] || 'black';
  });
  return mol;
};

export const restrictToSurvivingSubstrates = (compoundColorMapping, mapping, targetNode) => {
  const survivingAtoms = mapping[targetNode] || [];
  const res = Object.keys(compoundColorMapping).reduce((acc, currKey) => {
    const curr = compoundColorMapping[currKey];
    const clone = { ...acc };
    if (survivingAtoms.includes(currKey)) clone[currKey] = curr;
    return clone;
  }, {});
  return res;
};
